import { Injectable, Signal } from '@angular/core';
import { IProposalData, IProposalModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IProposalState, ProposalActions, ProposalSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ProposalStore extends StateAccessService<IProposalState> {
  readonly state$: Observable<IProposalState>;

  readonly data$$: Signal<IProposalData>;
  readonly model$$: Signal<IProposalModel>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(ProposalSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(ProposalSelectors.data);
  }

  dispatchProposalReset() {
    this.stateFacade.dispatch(ProposalActions.reset());
  }
  dispatchProposalLoad() {
    this.stateFacade.dispatch(ProposalActions.load());
  }
  dispatchProposalLoadSuccess({ model, data }: { model: IProposalModel; data: IProposalData }) {
    this.stateFacade.dispatch(ProposalActions.loadSuccess({ model, data }));
  }
  dispatchProposalSubmit() {
    this.stateFacade.dispatch(ProposalActions.submit());
  }
  dispatchProposalSubmitSuccess({ model, data }: { model: IProposalModel; data: IProposalData }) {
    this.stateFacade.dispatch(ProposalActions.submitSuccess({ model, data }));
  }
}
